<template>
    <q-modal v-model="visible" content-css="width: 800px;" content-classes="q-pa-lg">
        <h2>Настройка способов оплаты</h2>
        <q-select
            v-model="paymentMethod"
            stack-label="Способ оплаты"
            :options="paymentMethodsOptions"
            color="secondary"
            inverted
        />
        <component
            v-if="paymentMethod"
            :is="currentMethodComponent"
            :details.sync="currentMethodDetails"
            :provider="provider"
            @close="visible = false"
        />
    </q-modal>
</template>

<script>
import { QModal, QSelect } from 'quasar'

import { InvoiceMethod, LiqpayMethod, Privat24Method, StripeMethod, WayforpayMethod } from './methods'

import { PAYMENTS_LIST } from './const'

export default {
    name: 'PaymentMethodEdit',
    components: {
        QModal,
        QSelect,
        InvoiceMethod,
        WayforpayMethod,
        Privat24Method,
        LiqpayMethod,
        StripeMethod,
    },
    props: {
        value: Boolean,
        paymentDetails: Array,
        provider: Object,
    },
    computed: {
        visible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            },
        },
        paymentDetailsMethods () {
            return this.paymentDetails.map(item => item.payment_method)
        },
        paymentMethodsOptions () {
            return PAYMENTS_LIST
        },
        defaultPaymentMethod () {
            return 'invoice'
        },
        currentMethodComponent () {
            return this.paymentMethod + 'Method'
        },
        currentMethodDetails: {
            get () {
                return this.paymentDetails.find(item => item.payment_method === this.paymentMethod)
            },
            set (val) {
                let details = this.currentMethodDetails

                if (details) {
                    details = val
                } else {
                    this.paymentDetails.push(val)
                }

                this.$emit('update:paymentDetails', this.paymentDetails)
            },
        },
    },
    data () {
        return {
            paymentMethod: null,
        }
    },
    watch: {
        paymentDetails () {
            this.paymentMethod = this.getFirstPaymentMethod()
        },
    },
    methods: {
        getFirstPaymentMethod () {
            return this.paymentDetails.length ? this.paymentDetails[0].payment_method : this.defaultPaymentMethod
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PaymentMethodEdit/PaymentMethodEdit.vue